// extracted by mini-css-extract-plugin
export default {"container":"xba-z","oos":"yba-z","oosUx":"zba-z","selected":"Aba-z","labelOos":"Bba-z"};